import { defineComponent } from 'vue';
import { HomeService } from '@/services/home.service';
import { useService } from '@kaokei/use-vue-service';
import { useRouter } from 'vue-router';
export default defineComponent({
  name: 'HomeBanner',
  setup: function setup() {
    var homeService = useService(HomeService);
    homeService.getBanner();
    var router = useRouter();

    var onBannerClick = function onBannerClick(item) {
      router.push("/activity/".concat(item.type));
    };

    return {
      homeService: homeService,
      onBannerClick: onBannerClick
    };
  }
});